import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext'; // Импортируем AuthProvider
import { DateProvider } from './DateContext';
import Logout from './components/Logout';
import Login from './components/Login';
import Navbar from './components/Navbar';  // Импорт Navbar
import Menu from './components/Menu.jsx';
import Superadmin from './components/Superadmin.jsx';
import Dashboard from './components/Dashboard.jsx';
import VehicleListArhive from './components/VehicleListArhiv.jsx';
import AdminPanel from './components/AdminPanel.jsx';
import VehicleDetails from "./components/VehicleDetails";
import AddVehicle from './components/AddVehicles.jsx';
import EditVehicle from './components/EditVehicle.jsx';
import ComplectList from './components/AddComplect.jsx';
import DownloadReport from './components/DownloadReport.jsx';

function App() {


  return (
    <AuthProvider>
      <div className='body' style={{ overflow: "hidden" }}>
      <DateProvider>
        <Router>
        
        {/* <Header /> */}
          <Navbar />
          <Routes>
          <Route path="/report" element={<DownloadReport />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path='/Menu' element={<Menu />} />
            <Route path='/superadmin' element={<Superadmin />} />
            <Route path='/adminpanel' element={<AdminPanel />} />
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/arhiv' element={<VehicleListArhive />} />
            <Route path='/add' element={<AddVehicle />} />
          <Route path="/vehicles/:id" element={<VehicleDetails />} />
          <Route path="/update/:id" element={<EditVehicle />} />
          <Route path="/complect" element={<ComplectList />} />
          </Routes>
        </Router>
        </DateProvider>
      </div>
      
  </AuthProvider>
    
  );
}

export default App;
